import { DisplayAs } from './DisplayAs';

export default DisplayAs;
